import React, { useState } from 'react';
import DashboardLayout from "../layouts/DashboardLayout";
import { sendNotificationForMember, sendNotificationForAllMembers } from "../../api/AdminApi";

const NotificationManagementPage = () => {
    // 단일 멤버 알림
    const [singleMemberId, setSingleMemberId] = useState('');
    const [singleTitle, setSingleTitle] = useState('');
    const [singleContent, setSingleContent] = useState('');
    const [singleUrl, setSingleUrl] = useState('');

    // 전체 멤버 알림
    const [allTitle, setAllTitle] = useState('');
    const [allContent, setAllContent] = useState('');
    const [allUrl, setAllUrl] = useState('');

    const handleSingleNotification = async () => {
        if (!singleMemberId || !singleTitle || !singleContent) {
            alert('멤버 ID, 제목, 내용은 필수입니다.');
            return;
        }

        try {
            await sendNotificationForMember(singleMemberId, singleTitle, singleContent, singleUrl);
            alert('알림이 발송되었습니다.');
            setSingleMemberId('');
            setSingleTitle('');
            setSingleContent('');
            setSingleUrl('');
        } catch (error) {
            console.error('단일 멤버 알림 발송 실패:', error);
            alert('알림 발송에 실패했습니다.');
        }
    };

    const handleAllNotification = async () => {
        if (!allTitle || !allContent) {
            alert('제목, 내용은 필수입니다.');
            return;
        }

        const confirmed = window.confirm('정말로 전체 멤버에게 알림을 발송하시겠습니까?');
        if (!confirmed) return;

        try {
            await sendNotificationForAllMembers(allTitle, allContent, allUrl);
            alert('전체 멤버에게 알림이 발송되었습니다.');
            setAllTitle('');
            setAllContent('');
            setAllUrl('');
        } catch (error) {
            console.error('전체 멤버 알림 발송 실패:', error);
            alert('알림 발송에 실패했습니다.');
        }
    };

    return (
        <DashboardLayout>
            <div className="p-3">
                <h1 className="text-lg font-bold mb-3">알림 발송 시스템</h1>
                
                <div className="w-1/2">
                    {/* 단일 멤버 알림 발송 */}
                    <div className="bg-gray-100 border border-gray-300 p-2 mb-3">
                        <h2 className="text-xs font-bold mb-2">단일 멤버 알림 발송</h2>
                        <table className="w-full text-xs">
                            <tbody>
                                <tr>
                                    <td className="w-16 py-1">멤버 ID</td>
                                    <td className="py-1">
                                        <input 
                                            type="number" 
                                            value={singleMemberId}
                                            onChange={(e) => setSingleMemberId(e.target.value)}
                                            className="w-full border border-gray-300 px-1 py-1"
                                            placeholder="멤버 ID 입력"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className="py-1">제목</td>
                                    <td className="py-1">
                                        <input 
                                            type="text" 
                                            value={singleTitle}
                                            onChange={(e) => setSingleTitle(e.target.value)}
                                            className="w-full border border-gray-300 px-1 py-1"
                                            placeholder="알림 제목"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className="py-1">내용</td>
                                    <td className="py-1">
                                        <textarea 
                                            value={singleContent}
                                            onChange={(e) => setSingleContent(e.target.value)}
                                            rows="2"
                                            className="w-full border border-gray-300 px-1 py-1"
                                            placeholder="알림 내용"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className="py-1">URL</td>
                                    <td className="py-1">
                                        <input 
                                            type="text" 
                                            value={singleUrl}
                                            onChange={(e) => setSingleUrl(e.target.value)}
                                            className="w-full border border-gray-300 px-1 py-1"
                                            placeholder="연결할 URL (선택사항)"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td className="py-1">
                                        <button 
                                            onClick={handleSingleNotification}
                                            className="px-2 py-1 bg-gray-200 border border-gray-300 hover:bg-gray-300 text-xs"
                                        >
                                            발송
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* 전체 멤버 알림 발송 */}
                    <div className="bg-gray-100 border border-gray-300 p-2">
                        <h2 className="text-xs font-bold mb-2">전체 멤버 알림 발송</h2>
                        <table className="w-full text-xs">
                            <tbody>
                                <tr>
                                    <td className="w-16 py-1">제목</td>
                                    <td className="py-1">
                                        <input 
                                            type="text" 
                                            value={allTitle}
                                            onChange={(e) => setAllTitle(e.target.value)}
                                            className="w-full border border-gray-300 px-1 py-1"
                                            placeholder="알림 제목"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className="py-1">내용</td>
                                    <td className="py-1">
                                        <textarea 
                                            value={allContent}
                                            onChange={(e) => setAllContent(e.target.value)}
                                            rows="2"
                                            className="w-full border border-gray-300 px-1 py-1"
                                            placeholder="알림 내용"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className="py-1">URL</td>
                                    <td className="py-1">
                                        <input 
                                            type="text" 
                                            value={allUrl}
                                            onChange={(e) => setAllUrl(e.target.value)}
                                            className="w-full border border-gray-300 px-1 py-1"
                                            placeholder="연결할 URL (선택사항)"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td className="py-1">
                                        <button 
                                            onClick={handleAllNotification}
                                            className="px-2 py-1 bg-gray-200 border border-gray-300 hover:bg-gray-300 text-xs"
                                        >
                                            전체 발송
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </DashboardLayout>
    );
};

export default NotificationManagementPage;
